module.exports = __webpack_public_path__ + "static/media/corazón.e516f504.png";